import { render, staticRenderFns } from "./AddQuestion.vue?vue&type=template&id=c3f5ad30&scoped=true&"
import script from "./AddQuestion.vue?vue&type=script&lang=js&"
export * from "./AddQuestion.vue?vue&type=script&lang=js&"
import style0 from "./AddQuestion.vue?vue&type=style&index=0&id=c3f5ad30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f5ad30",
  null
  
)

export default component.exports